/**
 * Converts TemplateTextProperties object to CSS style object
 * @param {Object} textProps - TemplateTextProperties object
 * @param {boolean} textProps.textBold - Apply bold
 * @param {boolean} textProps.textItalic - Apply italic
 * @param {boolean} textProps.textUnderline - Apply underline
 * @param {string} textProps.textColor - Hex color code
 * @param {number} textProps.textFontPlus - Font size adjustment (-5 to +10)
 * @param {string} textProps.textAlign - Text alignment (left, center, right, justify)
 * @returns {Object} CSS style object
 */
export function convertTemplateTextPropertiesToStyle(textProps) {
  if (!textProps) return {}

  const style = {}

  if (textProps.textBold) {
    style.fontWeight = 'bold'
  }

  if (textProps.textItalic) {
    style.fontStyle = 'italic'
  }

  if (textProps.textUnderline) {
    style.textDecoration = 'underline'
  }

  if (textProps.textColor) {
    style.color = textProps.textColor
  }

  if (textProps.textFontPlus && textProps.textFontPlus !== 0) {
    style.fontSize = `calc(1em + ${textProps.textFontPlus}px)`
  }

  if (textProps.textAlign) {
    style.textAlign = textProps.textAlign
  }

  return style
}
